import React from "react";
import { CheckIcon, DownloadIcon, SmartphoneIcon, ReceiptIcon, CreditCardIcon } from "lucide-react";
import { offer } from "../data/offer";
import { CtaButton } from "./CtaButton";
import { PriceList } from "./PriceList";
import { BundleShowcase } from "./BundleShowcase";
const assurances = [{
  icon: ReceiptIcon,
  label: "Compra única"
}, {
  icon: DownloadIcon,
  label: "Descarga digital en PDF"
}, {
  icon: SmartphoneIcon,
  label: "Celular, compu o tablet"
}];
export function Offer() {
  return <section id="oferta" className="scroll-mt-14 bg-white py-20 md:py-28" aria-labelledby="offer-title" data-id="element-160" data-mp="p0jx550hobhm">
      <div className="mx-auto max-w-6xl px-5 md:px-8" data-id="element-161" data-mp="13y2g1qqhjuh5">
        <div className="grid overflow-hidden rounded-[2rem] ring-1 ring-line shadow-[0_30px_80px_-40px_rgba(18,40,60,0.35)] lg:grid-cols-[1fr_1.05fr] lg:rounded-[2.5rem]" data-id="element-162" data-mp="yxxzk0pkuzqx">
          <div className="flex items-center justify-center bg-paper px-6 py-10 sm:px-10 sm:py-14" data-id="element-163" data-mp="2fad3dhmgmye7">
            <BundleShowcase data-id="element-164" data-mp="2actqom5eutod" />
          </div>

          <div className="min-w-0 bg-white px-5 py-8 sm:p-10 lg:p-12" data-id="element-165" data-mp="pkqm655vjl7n">
            <h2 id="offer-title" className="font-display text-3xl font-semibold leading-tight text-ink md:text-4xl" data-id="element-166" data-mp="pml6pid8hbb7">
              Tu negocio puede empezar con una decisión.
            </h2>
            <p className="mt-3 leading-relaxed text-muted" data-id="element-167" data-mp="13ki4gi3fbnrg">
              Hoy podés acceder a todo el paquete con una sola compra.
            </p>

            <ul className="mt-7 grid gap-4 sm:grid-cols-2" data-id="element-168" data-mp="6vk9ayrrhntr">
              {offer.includes.map(item => <li key={item.title} className="flex items-start gap-3" data-id="element-169" data-mp="bqpt9s1lssf7">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-ink" data-id="element-170" data-mp="fsuouwbm3z4h">
                    <CheckIcon className="h-3.5 w-3.5 text-sun" strokeWidth={3.5} aria-hidden="true" data-id="element-171" data-mp="kmfg85ip9uup" />
                  </span>
                  <span data-id="element-172" data-mp="3oa7kgyfv5flq">
                    <span className="block font-bold text-ink" data-id="element-173" data-mp="3o9fnbj6mb9tc">{item.title}</span>
                    <span className="block text-sm leading-snug text-muted" data-id="element-174" data-mp="vfh6ode273lz">{item.detail}</span>
                  </span>
                </li>)}
            </ul>

            <div className="mt-8" data-id="element-175" data-mp="qetg1stqsosa">
              <PriceList data-id="element-176" data-mp="156243xhzy23b" />
            </div>

            <div className="mt-6" data-id="element-177" data-mp="154qw1lhiq86e">
              <CtaButton fullWidth data-id="element-178" data-mp="106pex63nkixk">Quiero mi kit completo</CtaButton>
            </div>

            <ul className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2" data-id="element-179" data-mp="108tjlq9dllyw">
              {assurances.map(({
              icon: Icon,
              label
            }) => <li key={label} className="flex items-center gap-1.5 text-sm font-semibold text-ink" data-id="element-180" data-mp="7itm4ch7fb62">
                  <Icon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-181" data-mp="lim5tnubcr4j" />
                  {label}
                </li>)}
            </ul>

            <p className="mt-6 flex items-start gap-2 border-t border-line pt-5 text-sm leading-relaxed text-muted" data-id="element-182" data-mp="1wwq0kw8q6jan">
              <CreditCardIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-183" data-mp="1svegf68meq9u" />
              Los medios de pago disponibles y el importe final se muestran en el checkout de la tienda antes de
              confirmar tu compra.
            </p>
          </div>
        </div>
      </div>
    </section>;
}